import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  userTypes: (state: State) => state.userTypes,
  userPermissions: (state: State) => state.userPermissions,
  rolePerm: (state: State) => state.rolePerm,
  userRolePermission: (state: State) => state.userRolePermission,
} as GetterTree<State, any>;